/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Search_Criteria_Label_Work_TypeInputs */

const en_jobs_search_criteria_label_work_type = /** @type {(inputs: Jobs_Search_Criteria_Label_Work_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work Type`)
};

const de_jobs_search_criteria_label_work_type = /** @type {(inputs: Jobs_Search_Criteria_Label_Work_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arbeitsmodell`)
};

const fr_jobs_search_criteria_label_work_type = /** @type {(inputs: Jobs_Search_Criteria_Label_Work_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de travail`)
};

const es_jobs_search_criteria_label_work_type = /** @type {(inputs: Jobs_Search_Criteria_Label_Work_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de trabajo`)
};

const it_jobs_search_criteria_label_work_type = /** @type {(inputs: Jobs_Search_Criteria_Label_Work_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di lavoro`)
};

const nl_jobs_search_criteria_label_work_type = /** @type {(inputs: Jobs_Search_Criteria_Label_Work_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werktype`)
};

const pl_jobs_search_criteria_label_work_type = /** @type {(inputs: Jobs_Search_Criteria_Label_Work_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ pracy`)
};

const fi_jobs_search_criteria_label_work_type = /** @type {(inputs: Jobs_Search_Criteria_Label_Work_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Työskentelymuoto`)
};

const da_jobs_search_criteria_label_work_type = /** @type {(inputs: Jobs_Search_Criteria_Label_Work_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arbejdstype`)
};

const sv_jobs_search_criteria_label_work_type = /** @type {(inputs: Jobs_Search_Criteria_Label_Work_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arbetstyp`)
};

/**
* | output |
* | --- |
* | "Work Type" |
*
* @param {Jobs_Search_Criteria_Label_Work_TypeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_search_criteria_label_work_type = /** @type {((inputs?: Jobs_Search_Criteria_Label_Work_TypeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Search_Criteria_Label_Work_TypeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_search_criteria_label_work_type(inputs)
	if (locale === "fr") return fr_jobs_search_criteria_label_work_type(inputs)
	if (locale === "es") return es_jobs_search_criteria_label_work_type(inputs)
	if (locale === "it") return it_jobs_search_criteria_label_work_type(inputs)
	if (locale === "nl") return nl_jobs_search_criteria_label_work_type(inputs)
	if (locale === "pl") return pl_jobs_search_criteria_label_work_type(inputs)
	if (locale === "fi") return fi_jobs_search_criteria_label_work_type(inputs)
	if (locale === "da") return da_jobs_search_criteria_label_work_type(inputs)
	if (locale === "sv") return sv_jobs_search_criteria_label_work_type(inputs)
	return en_jobs_search_criteria_label_work_type(inputs)
});